// Styles for __name__ go here.
import styled from 'styled-components';
import { toRem, baseVariables } from '../../styles';

export const StyledDropdownButton = styled.div`
  position: relative;
  .icon-arrow {
    &-down::before,
    &-up::before {
      font-size: ${toRem(10)};
      font-weight: 400;
    }
  }
  .visually-hidden {
    position: absolute;
    top: 0;
    right: 0;
    font-size: ${toRem(2)};
    color: transparent;
    cursor: pointer;
  }
  .list-container {
    position: absolute;
    top: ${toRem(40)};
    z-index: 3;
    max-width: ${toRem(300)};
    min-width: ${toRem(264)};
    margin-top: ${toRem(0)};
    border-radius: ${toRem(12)};
    box-shadow: 0 ${toRem(4)} ${toRem(20)} 0 rgba(0, 0, 0, 0.1);
    background-color: ${baseVariables.color.base20}!important;
  }
  .list-items {
    display: flex;
    flex-direction: column;
    padding: ${toRem(16)} ${toRem(25)};
    margin: ${toRem(0)};
    li {
      list-style: none;
      display: flex;
      margin-bottom: ${toRem(16)};
      padding-top: ${toRem(16)};
      font-size: ${toRem(13)};
      span.icon-arrow-right::before {
        font-size: ${toRem(16)};
        font-weight: 400;
      }
      a.list-item {
        color: ${baseVariables.color.base10}!important;
      }
    }
    div:last-child {
      .rule-container {
        display: none;
      }
    }
  }
`;
export const StyledDropdownModal = styled.div`
  .drop-modal-container {
    .custom-scrollbar {
      @media ${baseVariables.mediaQuery.md} {
        margin: ${toRem(0)};
        position: fixed;
        bottom: 0;
        max-width: 100%;
      }
    }
    .drop-modal-body {
      .list-items {
        .ruler-length-80 {
          width: 100%;
        }
      }
    }
  }
`;
